
import { computed, onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { minValue, required } from '@vuelidate/validators';
import { useStore } from 'vuex';

import numeral from 'numeral';

import useProductos from '@/modules/ventas/composables/useProductos';
import useProveedores from '../composables/useProveedores';
import useParametros from '../composables/useParametros';
import useCompras from '../composables/useCompras';

import utils from '@/utils/utils';

export default {
    setup() {
        const store = useStore();
        
        const PRESENTACION_PAQUETE = 2;

        const hoy = new Date();

        const { 
            buscarProductosPorCodigoBarras,
            buscarProductosPorIdProducto,
            obtenerProductosParaLaVentaCompra,
        } = useProductos();

        const { 
            obtenerProveedores
        } = useProveedores();

        const {
            obtenerTiposPago,
        } = useParametros();

        const {
            grabarCompra,
        } = useCompras();

        const filtroCodigoBarras = ref<any>('');
        const filtroNombreProducto = ref<any>('');

        const compra = ref<any>({
            id_compra: 0,
            id_sucursal: store.getters['auth/getIdSucursal'],
            id_proveedor: '',
            fecha_compra: hoy.getFullYear().toString()
                + '-' + ((hoy.getMonth() + 1) < 10 ? '0' + (hoy.getMonth() + 1).toString() : (hoy.getMonth() + 1).toString())
                + '-' + (hoy.getDate() < 10 ? '0' + hoy.getDate().toString() : hoy.getDate().toString()),
            id_tipo_pago: '1',
            total: 0.00,
            estado: true,
            comprasDetalle: [],
        });
        const reglasCompra = computed(() => ({
            id_proveedor: { required },
            fecha_compra: { required },
            id_tipo_pago: { required },
        }));
        const v$ = useVuelidate(reglasCompra, compra);
        const compraDetalle = ref<any>({
            id_compra_detalle: 0,
            id_compra: 0,
            id_producto: 0,
            id_producto_stock: 0,
            nombre_producto: '',
            cantidad: 1,
            precio_compra: 0,
            importe: 0
        });
        const reglasCompraDetalle = computed(() => ({
            cantidad: { required, minValue: minValue(0.01) },
            precio_compra: { required, minValue: minValue(0.01) },
        }));
        const vcd$ = useVuelidate(reglasCompraDetalle, compraDetalle);

        const proveedores = ref<any>([]);
        const tiposPago = ref<any>([]);

        const filtroProductoRef = ref();
        const cantidadRef = ref();

        const productos = ref<any>([]);

        const seGrabo = ref<boolean>(false);

        onMounted(async() => {
            filtroProductoRef.value.focus();

            let resp = await obtenerProveedores('');
            if (resp.ok) {
                proveedores.value = resp.data;
            }

            resp = await obtenerTiposPago();
            if (resp.ok) {
                tiposPago.value = resp.data;
            }

            resp = await obtenerProductosParaLaVentaCompra();
            if (resp.ok) {
                productos.value = resp.data;
            }
        });

        const buscarProducto = async() => {
            compraDetalle.value.id_producto = 0;
            compraDetalle.value.id_producto_stock = 0;
            compraDetalle.value.nombre_producto = '';
            compraDetalle.value.cantidad = 1;
            compraDetalle.value.precio_compra = 0;
            compraDetalle.value.importe = 0;

            if (filtroCodigoBarras.value.length > 0) {
                const resp = await buscarProductosPorCodigoBarras(filtroCodigoBarras.value)
                if (resp.ok && resp.data) {
                    const productoEncontrado: any = resp.data;

                    if (productoEncontrado.length > 0) {
                        compraDetalle.value.id_producto = productoEncontrado[0].id_producto;
                        compraDetalle.value.id_producto_stock = productoEncontrado[0].id_producto_stock;
                        compraDetalle.value.nombre_producto = productoEncontrado[0].nombre;
                        compraDetalle.value.precio_compra = productoEncontrado[0].precio_compra;
                        // Si el producto es por paquete.
                        if (productoEncontrado[0].id_presentacion == PRESENTACION_PAQUETE) {
                            compraDetalle.value.cantidad = productoEncontrado[0].cantidad_paquete;

                            const respProductoDetalle = await buscarProductosPorIdProducto(productoEncontrado[0].id_producto_detalle_paquete);
                            if (respProductoDetalle.ok) {
                                const productoDetalleEncintrado: any = respProductoDetalle.data;
                                
                                compraDetalle.value.id_producto = productoDetalleEncintrado[0].id_producto;
                                compraDetalle.value.id_producto_stock = productoDetalleEncintrado[0].id_producto_stock;
                                compraDetalle.value.nombre_producto = productoDetalleEncintrado[0].nombre;
                                compraDetalle.value.precio_compra = productoDetalleEncintrado[0].precio_compra;
                            }
                        }

                        calcularImporte();

                        setTimeout(() => {
                            cantidadRef.value.focus();
                        }, 0);
                    } else {
                        utils.mostrarMensaje({
                            descripcion: 'Producto no encontrado.',
                            tipoMensaje: 'warning'
                        })
                    }
                }
            }

            setTimeout(() => {
                filtroCodigoBarras.value = '';
                filtroNombreProducto.value = '';
            }, 0);
        }

        const asignarProductoSeleccionado = async() => {
            compraDetalle.value.id_producto = 0;
            compraDetalle.value.id_producto_stock = 0;
            compraDetalle.value.nombre_producto = '';
            compraDetalle.value.cantidad = 1;
            compraDetalle.value.precio_compra = 0;
            compraDetalle.value.importe = 0;

            const productoEncontrado = productos.value.filter((p: any) => p.id_producto == filtroNombreProducto.value);

            compraDetalle.value.id_producto = productoEncontrado[0].id_producto;
            compraDetalle.value.id_producto_stock = productoEncontrado[0].id_producto_stock;
            compraDetalle.value.nombre_producto = productoEncontrado[0].nombre;
            compraDetalle.value.precio_compra = productoEncontrado[0].precio_compra;
            // Si el producto es por paquete.
            if (productoEncontrado[0].id_presentacion == PRESENTACION_PAQUETE) {
                compraDetalle.value.cantidad = productoEncontrado[0].cantidad_paquete;

                const respProductoDetalle = await buscarProductosPorIdProducto(productoEncontrado[0].id_producto_detalle_paquete);
                if (respProductoDetalle.ok) {
                    const productoDetalleEncintrado: any = respProductoDetalle.data;
                    
                    compraDetalle.value.id_producto = productoDetalleEncintrado[0].id_producto;
                    compraDetalle.value.id_producto_stock = productoDetalleEncintrado[0].id_producto_stock;
                    compraDetalle.value.nombre_producto = productoDetalleEncintrado[0].nombre;
                    compraDetalle.value.precio_compra = productoDetalleEncintrado[0].precio_compra;
                }
            }

            calcularImporte();

            setTimeout(() => {
                cantidadRef.value.focus();

                filtroCodigoBarras.value = '';
                filtroNombreProducto.value = '';
            }, 0);
        }

        const calcularImporte = () => {
            compraDetalle.value.importe = (compraDetalle.value.precio_compra * compraDetalle.value.cantidad).toFixed(2);
        }

        const keyPressCantidad = ($event: any) => {
            if ($event.key === '.') {
                $event.preventDefault();
            }
        }

        const keyPressPrecioCompra = ($event: any) => {
            if (compraDetalle.value.precio_compra.toString().split('.').length == 2) {
                if (compraDetalle.value.precio_compra.toString().split('.')[1].length == 2) {
                    $event.preventDefault();
                }
            }
        }

        const adicionarDetalleVenta = async () => {
            if (!vcd$.value.$invalid) {
                calcularImporte();
                compra.value.comprasDetalle.push(JSON.parse(JSON.stringify(compraDetalle.value)));
                compra.value.total = compra.value.comprasDetalle.reduce((sumaParcial: number, i: any) => sumaParcial + Number(i.importe), 0);

                compraDetalle.value.id_producto = 0;
                compraDetalle.value.id_producto_stock = 0;
                compraDetalle.value.nombre_producto = '';
                compraDetalle.value.cantidad = 1;
                compraDetalle.value.precio_compra = 0;
                compraDetalle.value.importe = 0;

                filtroProductoRef.value.focus();
                vcd$.value.$reset();
            } else {
                vcd$.value.$touch();
            }
        }

        const eliminarDetalleFactura = (index: number) => {
            compra.value.comprasDetalle.splice(index, 1);

            compra.value.total = compra.value.comprasDetalle.reduce((sumaParcial: number, i: any) => sumaParcial + Number(i.importe), 0);
        }

        const nuevaCompra = () => {
            compra.value = {
                id_compra: 0,
                id_sucursal: store.getters['auth/getIdSucursal'],
                id_proveedor: '',
                fecha_compra: hoy.getFullYear().toString()
                    + '-' + ((hoy.getMonth() + 1) < 10 ? '0' + (hoy.getMonth() + 1).toString() : (hoy.getMonth() + 1).toString())
                    + '-' + (hoy.getDate() < 10 ? '0' + hoy.getDate().toString() : hoy.getDate().toString()),
                id_tipo_pago: '1',
                total: 0.00,
                estado: true,
                comprasDetalle: [],
            };

            compraDetalle.value.id_compra_detalle = 0;
            compraDetalle.value.id_compra = 0;
            compraDetalle.value.id_producto = 0;
            compraDetalle.value.id_producto_stock = 0;
            compraDetalle.value.nombre_producto = '';
            compraDetalle.value.cantidad = 1;
            compraDetalle.value.precio_compra = 0;
            compraDetalle.value.importe = 0;

            filtroProductoRef.value.focus();

            v$.value.$reset();
            vcd$.value.$reset();

            seGrabo.value = false;
        }

        const grabarCompraFunction = async() => {
            if (!v$.value.$invalid) {
                const respPregunta = await utils.mensajePregunta('¿Está seguro de grabar la compra?')
                if (respPregunta) {
                    const resp = await grabarCompra(compra.value);
                    if (resp.ok) {
                        compra.value.id_compra = resp.data;

                        seGrabo.value = true;
                    }
                }
            } else {
                v$.value.$touch();
            }
        }

        return {
            filtroCodigoBarras,
            filtroNombreProducto,
            compra,
            compraDetalle,
            proveedores,
            productos,
            tiposPago,
            seGrabo,

            buscarProducto,
            asignarProductoSeleccionado,
            nuevaCompra,
            grabarCompraFunction,
            calcularImporte,
            keyPressCantidad,
            keyPressPrecioCompra,
            adicionarDetalleVenta,
            numeral,
            eliminarDetalleFactura,

            v$,
            vcd$,

            filtroProductoRef,
            cantidadRef,
        };
    }
}
